import _ from 'lodash';
import Promise from 'bluebird';

// import {EN_US} from "../data/strings.en_us.js";

export var strings = {
    mappings: {},
    get( ...path ) {
        var fullPath = path.join('.');
        var result = _.get(this.mappings, fullPath);
        return result ? result : `? ${fullPath}`;
    },

    // TODO Hardcoded for now. Need to actually make a request here
    load( url ) {
        return new Promise((resolve, reject) => {
            this.mappings = url;
            resolve(this);
        });
    }
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/strings.js
// module id = 11
// module chunks = 0